export enum Role {
  ADMIN = 'Admin',
  INVITED = 'Invited',
  PTL = 'PTL',
  PRM = 'PRM',
  OEA = 'OEA',
  OEG = 'OEG',
}
